import { baseApi } from "./baseApi";

const DRIVER_BASE_URL = "/drivers";

export const driverApi = baseApi.injectEndpoints({
  tagTypes: ["Driver"],

  endpoints: (build) => ({
    addDriver: build.mutation({
      query: (payload) => ({
        url: DRIVER_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "Driver", id: "LIST" }],
    }),

    listDriver: build.query({
      query: (params) => ({
        url: DRIVER_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Driver", _id })),
            { type: "Driver", id: "LIST" },
          ]
          : [{ type: "Driver", id: "LIST" }],
    }),
    listDriverForLicences: build.query({
      query: (params) => ({
        url: `${DRIVER_BASE_URL}/licences`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Driver", _id })),
            { type: "Driver", id: "LIST" },
          ]
          : [{ type: "Driver", id: "LIST" }],
    }),
    // Fix your RTK Query configuration
    getDriverStatistics: build.query({
      query: ({ driverId, params }) => {
        return {
          url: `${DRIVER_BASE_URL}/${driverId}/getDriverActivityCount`,
          method: "GET",
          params: params,
        };
      },
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ id }) => ({ type: "Driver", id })),
            { type: "Driver", id: "LIST" },
          ]
          : [{ type: "Driver", id: "LIST" }],
    }),

    listDriverForContractor: build.query({
      query: (params) => ({
        url: `${DRIVER_BASE_URL}/driverlist`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Driver", _id })),
            { type: "Driver", id: "LIST" },
          ]
          : [{ type: "Driver", id: "LIST" }],
    }),

    getDDLDriverList: build.query({
      query: (params) => ({ url: `${DRIVER_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Driver", _id })),
            { type: "Driver", id: "DDL" },
          ]
          : [{ type: "Driver", id: "DDL" }],
    }),
    getDDLLoggedInDriver: build.query({
      query: (params) => ({
        url: `${DRIVER_BASE_URL}/ddlLoggedInDriverWithVehicle`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Driver", _id })),
            { type: "Driver", id: "DDL" },
          ]
          : [{ type: "Driver", id: "DDL" }],
    }),
    getDDLDriverListByContractor: build.query({
      query: ({ contractorId, ...params }) => ({
        url: `${DRIVER_BASE_URL}/ddl/by-contractor/${contractorId}`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ value }) => ({ type: "Driver", id: value })),
            { type: "Driver", id: "DDL" },
          ]
          : [{ type: "Driver", id: "DDL" }],
    }),

    getDriverDetail: build.query({
      query: (driverId) => `${DRIVER_BASE_URL}/${driverId}`,
      providesTags: (result, error, { _id }) => [
        { type: "Driver", _id },
        { type: "Driver", id: "LIST" },
      ],
    }),
    getDriverToUnloadShipments: build.query({
      query: ({ driverId, page = 1, limit = 10, keyword }) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/to-unload`,
        params: { page, limit, ...(keyword && { keyword }) },
      }),
      providesTags: (result, error, { driverId }) => [
        { type: "Driver", id: `${driverId}-to-unload` },
      ],
    }),
    getDriverAndVehicleDetail: build.query({
      query: (driverIds) =>
        `${DRIVER_BASE_URL}/${driverIds}/driver-vehicle-detail`,
      providesTags: (result, error, { _id }) => [
        { type: "Driver", _id },
        { type: "Driver", id: "LIST" },
      ],
    }),

    searchDriversForTransfer: build.query({
      query: ({ q, excludeId }) => ({
        url: `${DRIVER_BASE_URL}/search`,
        params: { q, excludeId },
      }),
      providesTags: [{ type: "Driver", id: "SEARCH" }],
    }),

    getDriverAssignments: build.query({
      query: (params) => ({
        url: `${DRIVER_BASE_URL}/assignments`,
        params,
      }),
      providesTags: (result, error, arg) => [
        { type: "DriverAssignment", id: `${arg.type}-${arg.driverId}` },
        { type: "DriverAssignment", id: "LIST" },
      ],
    }),

    getDriverShipmentCounts: build.query({
      query: (driverId) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/shipment-counts`,
      }),
      providesTags: (result, error, id) => [
        { type: "DriverShipmentCounts", id },
      ],
    }),

    searchDriversWithVehiclesForTransfer: build.query({
      query: ({ q, excludeId }) => ({
        url: `${DRIVER_BASE_URL}/search-with-vehicles`,
        params: { q, excludeId },
      }),
      providesTags: [{ type: "Driver", id: "SEARCH_WITH_VEHICLES" }],
    }),

    updateDriver: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${DRIVER_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "Driver", id },
        { type: "Driver", id: "LIST" },
      ],
    }),

    //Adding new Driver History
    addDriverHistory: build.mutation({
      query: (payload) => {
        const { driverId, ...body } = payload;

        return {
          url: `${DRIVER_BASE_URL}/${driverId}/driverHistories`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Driver", id: _id },
        { type: "Driver", id: "LIST" },
      ],
    }),

    updateDriverHistory: build.mutation({
      query: (payload) => {
        const { driverId, tripId, ...body } = payload;

        return {
          url: `${DRIVER_BASE_URL}/${driverId}/driverHistories/${tripId}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Driver", id: _id },
        { type: "Driver", id: "LIST" },
      ],
    }),

    listDriverHistory: build.query({
      query: ({ driverId, page, limit, active }) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/driverHistories`,
        params: { page, limit, active },
      }),

      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Driver", _id })),
            { type: "Driver", id: "LIST" },
          ]
          : [{ type: "Driver", id: "LIST" }],
    }),
    // adding new work schedule
    addWorkSchedule: build.mutation({
      query: (payload) => {
        const { driverId, ...body } = payload;
        return {
          url: `${DRIVER_BASE_URL}/${driverId}/driverSchedules`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Driver", id: _id },
        { type: "Driver", id: "LIST" },
      ],
    }),

    updateWorkSchedule: build.mutation({
      query: (payload) => {
        const { driverId, scheduleId, ...body } = payload;

        return {
          url: `${DRIVER_BASE_URL}/${driverId}/driverSchedules/${scheduleId}`,
          method: "PUT",
          body,
        };
      },

      invalidatesTags: (result, error, { _id }) => [
        { type: "Driver", id: _id },
        { type: "Driver", id: "LIST" },
      ],
    }),

    listDriverSchedule: build.query({
      query: ({ driverId, page, limit, active }) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/driverSchedules`,
        params: { page, limit, active },
      }),

      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Driver", _id })),
            { type: "Driver", id: "LIST" },
          ]
          : [{ type: "Driver", id: "LIST" }],
    }),

    addDriverLicence: build.mutation({
      query: (payload) => {
        const { driverId, ...body } = payload;
        return {
          url: `${DRIVER_BASE_URL}/${driverId}/driverLicences`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Driver", id: _id },
        { type: "Driver", id: "LIST" },
      ],
    }),

    listDriverLicence: build.query({
      query: ({ driverId, page, limit, active }) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/driverLicences`,
        params: { page, limit, active },
      }),

      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Driver", _id })),
            { type: "Driver", id: "LIST" },
          ]
          : [{ type: "Driver", id: "LIST" }],
    }),

    //updating existing licence
    updateDriverLicence: build.mutation({
      query: (payload) => {
        const { driverId, licenceId, ...body } = payload;

        return {
          url: `${DRIVER_BASE_URL}/${driverId}/driverLicences/${licenceId}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Driver", id: _id },
        { type: "Driver", id: "LIST" },
      ],
    }),

    listPaymentPricesByDriverId: build.query({
      query: ({ driverId, page, limit }) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/payment-prices`,
        params: { page, limit },
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Driver", _id })),
            { type: "Driver", id: "LIST" },
          ]
          : [{ type: "Driver", id: "LIST" }],
    }),
    getBranchWiseLoadingStats: build.query({
      query: ({ driverId }) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/branch-wise-loading`,
      }),
    }),
    getBranchWiseUnloadingStats: build.query({
      query: ({ driverId }) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/branch-wise-unloading`,
      }),
    }),
    getBranchWiseUnloadingStatsCount: build.query({
      query: ({ driverId }) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/branch-wise-unloading-count`,
      }),
    }),
    getBranchShipmentsList: build.query({
      query: ({ driverId, branchId, type = "loading" }) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/branch-shipments/${branchId}?type=${type}`,
        method: "GET",
      }),
      providesTags: ["Driver"],
    }),
    getDDLDriversForDelivery: build.query({
      query: (params) => ({
        url: `${DRIVER_BASE_URL}/ddl/for-delivery`,
        params,
      }),
      providesTags: [{ type: "Driver", id: "DDL-DELIVERY" }],
    }),

    // Lazy: drivers assigned to a specific vehicle
    // (used by Vehicle Hiring Entry form to populate driver dropdown).
    getDriversByVehicle: build.query({
      query: (vehicleId) =>
        `${DRIVER_BASE_URL}/by-vehicle/${vehicleId}`,
      providesTags: (result, error, vehicleId) => [
        { type: "Driver", id: `BY-VEHICLE-${vehicleId}` },
      ],
    }),

    // Lazy: minimal driver detail (name, ownerphone, bankAccountDetails)
    // for the selected driver.
    getDriverContactAndBank: build.query({
      query: (driverId) => `${DRIVER_BASE_URL}/${driverId}`,
      providesTags: (result, error, id) => [
        { type: "Driver", id: `CONTACT-${id}` },
      ],
    }),

    // Targeted PATCH to update only ownerphone + bankAccountDetails
    // (used by Vehicle Hiring Entry form's "Add to Driver" button).
    updateDriverContactAndBank: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${DRIVER_BASE_URL}/${id}/contact-bank`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Driver", id },
        { type: "Driver", id: "LIST" },
        { type: "Driver", id: "DDL" },
      ],
    }),

    getShipmentsForNotes: build.query({
      query: (params) => ({
        url: `${DRIVER_BASE_URL}/shipments-for-notes`,
        params,
      }),
      providesTags: [{ type: "Shipment", id: "BY-DRIVER" }],
    }),

    // Lazy: Get shipments only when driver is selected
    getDriverShipmentsWithPrices: build.query({
      query: ({ driverId, ...params }) => ({
        url: `${DRIVER_BASE_URL}/${driverId}/shipments-with-prices`,
        params,
      }),
      providesTags: (result, error, { driverId }) => [
        { type: "DriverShipments", id: driverId },
      ],
    }),

    transferVehicleShipments: build.mutation({
      query: ({
        driverId,
        loadingIds,
        vehicleId,
        vehicleVehicleId,
        vehicleRegistrationNumber,
        account,
        entity,
      }) => ({
        url: `${DRIVER_BASE_URL}/transfer-vehicle-shipments`,
        method: "PUT",
        body: {
          driverId,
          loadingIds,
          vehicleId,
          vehicleVehicleId,
          vehicleRegistrationNumber,
          account,
          entity,
        },
      }),
      invalidatesTags: [
        { type: "ShipmentLoading", id: "VEHICLE-LOADING-SUMMARY" },
      ],
    }),

    partialTransferVehicleShipments: build.mutation({
      query: ({
        toDriverId,
        fromVehicle,
        toVehicle,
        loadingIds,
        account,
        entity,
      }) => ({
        url: `${DRIVER_BASE_URL}/partial-transfer-vehicle-shipments`,
        method: "PUT",
        body: {
          toDriverId,
          fromVehicle,
          toVehicle,
          loadingIds,
          account,
          entity,
        },
      }),
      invalidatesTags: [
        { type: "ShipmentLoading", id: "VEHICLE-LOADING-SUMMARY" },
      ],
    }),

    getPendingTransferRequests: build.query({
      query: (driverId) => ({
        url: `${DRIVER_BASE_URL}/transfer-requests/${driverId}/pending`,
        method: "GET",
      }),
      providesTags: [{ type: "TransferRequest", id: "PENDING" }],
    }),

    respondToTransferRequest: build.mutation({
      query: ({ id, action }) => ({
        url: `${DRIVER_BASE_URL}/transfer-requests/${id}/respond`,
        method: "PUT",
        body: { action },
      }),
      invalidatesTags: [
        { type: "TransferRequest", id: "PENDING" },
        { type: "ShipmentLoading", id: "VEHICLE-LOADING-SUMMARY" },
      ],
    }),

    transferLoadAndShipmentFromAdmin: build.mutation({
      query: (body) => ({
        url: `${DRIVER_BASE_URL}/transfer-shipment`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { fromDriverId }) => [
        { type: "Driver", id: fromDriverId },
        { type: "ShipmentLoading", id: `DRIVER-${fromDriverId}` },
        { type: "ShipmentLoading", id: "DRIVER-LOADING-SUMMARY" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListDriverQuery,
  useLazyListDriverQuery,
  useLazyListDriverForLicencesQuery,
  useLazyListDriverForContractorQuery,
  useLazyListDriverLicenceQuery,
  useLazyListDriverScheduleQuery,
  useLazyListDriverHistoryQuery,
  useGetDDLDriverListQuery,
  useLazyGetDDLDriverListQuery,
  useLazyGetDDLLoggedInDriverQuery,
  useGetDDLDriverListByContractorQuery,
  useLazyGetDDLDriverListByContractorQuery,
  useGetDDLDriversForDeliveryQuery,
  useLazyGetShipmentsForNotesQuery,
  useLazyGetDriverShipmentsWithPricesQuery,
  useAddDriverMutation,
  useGetDriverDetailQuery,
  useLazyGetDriverAndVehicleDetailQuery,
  useUpdateDriverMutation,
  useAddWorkScheduleMutation,
  useUpdateWorkScheduleMutation,
  useLazyGetDriverStatisticsQuery,
  useAddDriverHistoryMutation,
  useUpdateDriverHistoryMutation,
  useAddDriverLicenceMutation,
  useUpdateDriverLicenceMutation,
  useListDriverLicenceQuery,
  useListDriverHistoryQuery,
  useListDriverScheduleQuery,
  useListPaymentPricesByDriverIdQuery,
  useGetBranchWiseLoadingStatsQuery,
  useGetBranchWiseUnloadingStatsQuery,
  useLazyGetBranchWiseLoadingStatsQuery,
  useLazyGetBranchWiseUnloadingStatsQuery,
  useLazyGetBranchWiseUnloadingStatsCountQuery,
  useLazyGetBranchShipmentsListQuery,
  useLazySearchDriversForTransferQuery,
  useLazySearchDriversWithVehiclesForTransferQuery,
  useTransferVehicleShipmentsMutation,
  usePartialTransferVehicleShipmentsMutation,
  useLazyGetPendingTransferRequestsQuery,
  useRespondToTransferRequestMutation,
  useLazyGetDriverAssignmentsQuery,
  useLazyGetDriverShipmentCountsQuery,
  useTransferLoadAndShipmentFromAdminMutation,
  useLazyGetDriverToUnloadShipmentsQuery,
  useLazyGetDriversByVehicleQuery,
  useLazyGetDriverContactAndBankQuery,
  useUpdateDriverContactAndBankMutation,
} = driverApi;
